<template>
  <NuxtLayout>
    <div class="forgottenPassword container">
      <template v-if="!passwordChanged">
        <h1 v-text="$t('forgottenPassword.createNewTitle')" />
        <form @submit.prevent="submitForm" class="absoluteLabelsForm forgottenPassword__Form">
          <TextField v-model="form.email" :label="$t('forms.email')" type="email" :errors="formErrors?.field_errors?.email" />
          <TextField class="form__PasswordField form__PasswordFirstField" v-model="form.password" :label="$t('forms.password')" type="password" :info="$t('forms.passwordNotice')" :errors="formErrors?.field_errors?.password">
            <template #append>
              <button type="button" @click="togglePasswordVisibility">
                <Icon name="password" />
                <Icon name="password-hide" />
              </button>
            </template>
          </TextField>
          <TextField class="form__PasswordField form__PasswordRepeatField" v-model="form.confirm_password" :label="$t('forms.passwordRepeat')" type="password" :errors="formErrors?.field_errors?.confirm_password">
            <template #append>
              <button type="button" @click="togglePasswordVisibility($event, repeat = true)">
                <Icon name="password" />
                <Icon name="password-hide" />
              </button>
            </template>
          </TextField>
          <Button class="forgottenPassword__FormButton" medium full-width :disabled="dataFetchInProgress">{{ $t('forgottenPassword.submit') }}</Button>
        </form>
      </template>
      <template v-else>
        <div class="forgottenPassword__Message">
          <Icon name="check-circle-fill"/>
          <h2>{{ $t('forgottenPassword.passwordChanged') }}</h2>
          <Button type="nuxt-link" :to="link('Loyalty')" class="forgottenPassword__FormButton" medium full-width>{{ $t('close') }}</Button>
        </div>
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });

  const props = defineProps({
    page: {
      type: Object
    }
  })

  const { link } = useSetup();
  const route = useRoute();

  const dataFetchInProgress = ref(false);
  const passwordChanged = ref(false);
  const operationToken = ref('');
  const formErrors = ref(null);
  const { customError, setCustomError } = useCustomFormErrors(formErrors.value);
  const form = ref({
    email: '',
    password: '',
    confirm_password: '',
  });

  if (route?.query?.operation_token) {
    operationToken.value = route.query.operation_token;
  }

  async function submitForm() {
    dataFetchInProgress.value = true;
    try {
      let body = JSON.parse(JSON.stringify(form.value));
      for (let [key, value] of Object.entries(body)) {
        if (value === '') {
          body[key] = null;
        }
      }
      if (operationToken.value) {
        body.operation_token = operationToken.value;
      }
      await useAuthFetch(`loyalty/confirm/`, {
        method: 'POST',
        strategy: 'aminess',
        body: body,
        headers: {
          'Application-Origin': 'SHAPE-WEB'
        }
      });
      passwordChanged.value = true;
    } catch(error) {
      console.log(error)
      if (error.data) formErrors.value = error.data;
      setCustomError(formErrors.value);
    }
    dataFetchInProgress.value = false;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_forgottenPassword.scss');
</style>